module.exports = __webpack_public_path__ + "img/penta5classic_bg.f503314c.png";